export const environment = {
  production: false,
  apiBaseUrl: 'https://back-kpi.tupide.mx',
};
